import { GroupTypes } from '@carm/_core/access-control-mgt/models/acl.model';
import {
  ApplicationFeatureName,
  IApplicationFeature,
} from '@carm/_utils/models';
import { RoutesConst } from '@carm/shared/constants/const-routes';
import { CarmResources } from '@carm/_core/access-control-mgt/models';
import { FinancialSecurityRequestSource } from '@carm/_core/financial-security/models/financial-security.model';

export const applicationFeatures = new Map<
  ApplicationFeatureName,
  IApplicationFeature
>();

applicationFeatures.set(ApplicationFeatureName.ACCOUNTS_AND_PROFILES, {
  path: RoutesConst.AccountProfile,
  localizationKey: 'application_features.accountsAndProfiles',
  dataCy: 'accounts-profiles-feature',
  acl: [
    {
      resource: CarmResources.PROGRAM,
      group: GroupTypes.Reader,
    },
  ],
  sections: [
    {
      localizationKey: 'businessProfile',
      path: RoutesConst.AccountProfile_BusinessProfile,
      dataCy: 'business-profile-section',
      acl: [
        {
          resource: CarmResources.BUSINESS,
          group: GroupTypes.Reader,
        },
      ],
    },
    {
      localizationKey: 'programAccountProfile',
      path: RoutesConst.AccountProfile_ProgramAccountProfile,
      dataCy: 'program-account-profile-section',
      acl: [
        {
          resource: CarmResources.PROGRAM,
          group: GroupTypes.Reader,
        },
      ],
    },
    {
      localizationKey: 'programAccounts',
      path: RoutesConst.AccountProfile_ListOfProgramAccount,
      dataCy: 'program-accounts-section',
      acl: [
        {
          resource: CarmResources.BUSINESS,
          group: GroupTypes.Reader,
        },
        {
          resource: CarmResources.PROGRAM_ENROLMENT,
          group: GroupTypes.Reader,
        },
        {
          resource: CarmResources.PROGRAM,
          group: GroupTypes.Reader,
        },
      ],
    }
  ],
});

applicationFeatures.set(ApplicationFeatureName.FINANCIAL_INFORMATION, {
  path: RoutesConst.Financial,
  localizationKey: 'application_features.financialInformation',
  dataCy: 'financial-information-section',
  numberOfColumns: 3,
  acl: [
    {
      resource: CarmResources.TRANSACTION_HISTORY,
      group: GroupTypes.Reader
    },
    {
      resource: CarmResources.FINANCIAL_STATEMENTS,
      group: GroupTypes.Reader
    },
    {
      resource: CarmResources.BROKER_SUMMARY,
      group: GroupTypes.Reader
    },
    {
      resource: CarmResources.CLIENT_TRANSACTION_HISTORY,
      group: GroupTypes.Reader,
    },
    {
      resource: CarmResources.COLLECTIONS,
      group: GroupTypes.Reader
    },
    {
      resource: CarmResources.BONDS_DASHBOARD,
      group: GroupTypes.Reader,
    },
    {
      resource: CarmResources.BONDS_LIST,
      group: GroupTypes.Reader,
    },
    {
      resource: CarmResources.SURETY_PROVIDER,
      group: GroupTypes.Reader,
    },
    {
      resource: CarmResources.INTEREST_SIMULATION,
      group: GroupTypes.Reader,
    },
  ],
  sections: [
    {
      localizationKey: 'transactionHistory',
      path: RoutesConst.Financial_TransactionHistory,
      dataCy: 'transaction-history-section',
      acl: [
        {
          resource: CarmResources.TRANSACTION_HISTORY,
          group: GroupTypes.Reader,
        }
      ],
      columnPosition: 1,
    },
    {
      localizationKey: 'statementAccount',
      path: RoutesConst.Financial_StatementAccount,
      dataCy: 'statement-account-section',
      acl: [
        {
          resource: CarmResources.FINANCIAL_STATEMENTS,
          group: GroupTypes.Reader,
        },
      ],
      columnPosition: 1,
    },
    {
      localizationKey: 'brokerSummaryReport',
      path: RoutesConst.Financial_BrokerSummaryReport,
      dataCy: 'broker-summary-report-section',
      acl: [
        {
          resource: CarmResources.BROKER_SUMMARY,
          group: GroupTypes.Reader,
        },
      ],
      columnPosition: 1,
    },
    {
      localizationKey: 'clientsTransactionHistory',
      path: RoutesConst.Financial_ClientTransactionHistory,
      dataCy: 'clients-transaction-history-section',
      acl: [
        {
          resource: CarmResources.CLIENT_TRANSACTION_HISTORY,
          group: GroupTypes.Reader,
        },
      ],
      columnPosition: 2,
    },
    {
      localizationKey: 'cbsaInvoices',
      path: RoutesConst.Financial_Invoice,
      dataCy: 'cbsa-invoices-section',
      acl: [
        {
          resource: CarmResources.FINANCIAL_STATEMENTS,
          group: GroupTypes.Reader,
        },
      ],
      columnPosition: 2,
    },
    {
      localizationKey: 'collectionLetters',
      path: RoutesConst.Financial_CollectionLetters,
      dataCy: 'collection-letters-section',
      acl: [
        {
          resource: CarmResources.COLLECTIONS,
          group: GroupTypes.Reader,
        },
      ],
      columnPosition: 3,
    },
    {
      localizationKey: 'financialSecurity',
      path: RoutesConst.Financial_FinancialSecurity,
      dataCy: 'financial-security-section',
      acl: [
        {
          resource: CarmResources.BONDS_DASHBOARD,
          group: GroupTypes.Reader,
        },
        {
          resource: CarmResources.BONDS_LIST,
          group: GroupTypes.Reader,
        }
      ],
      columnPosition: 3,
    },
    {
      localizationKey: 'suretyBonds',
      dataCy: 'surety-bonds-section',
      path: RoutesConst.FinancialSecurityEnrolment_surety_dashboard,
      acl: [
        {
          resource: CarmResources.SURETY_PROVIDER,
          group: GroupTypes.Reader,
        },
      ],
      columnPosition: 3,
    },
    {
      localizationKey: 'latePaymentInterestSimulation',
      path: RoutesConst.Financial_LatePaymentInterestSimulation,
      dataCy: 'late-payment-interest-simulation-section',
      acl: [
        {
          resource: CarmResources.INTEREST_SIMULATION,
          group: GroupTypes.Reader,
        },
      ],
      columnPosition: 2,
    },
  ],
});

applicationFeatures.set(ApplicationFeatureName.PAYMENTS, {
  path: RoutesConst.Payments,
  localizationKey: 'application_features.payments',
  dataCy: 'payments-feature',
  acl: [
    {
      resource: CarmResources.PAYMENTS,
      group: GroupTypes.Reader
    },
    {
      resource: CarmResources.APPLY_CREDITS,
      group: GroupTypes.Reader
    },
  ],
  sections: [
    {
      localizationKey: 'applyCreditsPayments',
      path: RoutesConst.Payments_ApplyCredit,
      dataCy: 'apply-credits-payments-section',
      acl: [
        {
          resource: CarmResources.APPLY_CREDITS,
          group: GroupTypes.Reader
        },
      ],
    },
    {
      localizationKey: 'preAuthorizedDebit',
      path: RoutesConst.Payments_PreAuthorizedDebit,
      dataCy: 'pre-authorized-debit-section',
      acl: [
        {
          resource: CarmResources.PAYMENTS,
          group: GroupTypes.Reader,
        },
      ],
    },
    {
      localizationKey: 'arrangements',
      dataCy: 'arrangements-section',
      path: RoutesConst.Payments_Arrangement,
      acl: [
        {
          resource: CarmResources.PAYMENTS,
          group: GroupTypes.Reader,
        },
      ],
    },
    {
      localizationKey: 'onlinePayment',
      dataCy: 'online-payment-section',
      path: RoutesConst.Payments_Online_Payment,
      requestSource: FinancialSecurityRequestSource.Payments,
      acl: [
        {
          resource: CarmResources.MAKE_PAYMENT,
          group: GroupTypes.Editor,
        },
      ],
    },
  ],
});

applicationFeatures.set(ApplicationFeatureName.DECLARATIONS, {
  path: RoutesConst.Declarations,
  localizationKey: 'application_features.declarations',
  dataCy: 'declarations-feature',
  numberOfColumns: 2,
  acl: [
    {
      resource: CarmResources.DECLARATIONS,
      group: GroupTypes.Reader,
    },
    {
      resource: CarmResources.DUTY_AND_TAX,
      group: GroupTypes.Reader,
    },
    {
      resource: CarmResources.DECLARATIONS_DDB_NONIMP,
      group: GroupTypes.Reader,
    },
  ],
  sections: [
    {
      localizationKey: 'dutiesTaxesCalculator',
      path: RoutesConst.Declarations_Calculator_Home,
      dataCy: 'duties-taxes-calculator-section',
      acl: [
        {
          resource: CarmResources.DUTY_AND_TAX,
          group: GroupTypes.Reader,
        },
      ]
    },
    {
      localizationKey: 'newDeclarations',
      path: RoutesConst.Declarations_Mgt_NewDeclarations,
      dataCy: 'new-declarations-section',
      acl: [
        {
          resource: CarmResources.DECLARATIONS,
          group: GroupTypes.Reader,
        },
      ]
    },
    {
      localizationKey: 'listDeclarations',
      path: RoutesConst.Declarations_List_Submitted,
      dataCy: 'list-declarations-section',
      acl: [
        {
          resource: CarmResources.DECLARATIONS,
          group: GroupTypes.Reader,
        },
      ]
    },
    {
      localizationKey: 'manageTemplates',
      path: RoutesConst.Declarations_Templates_Vendors,
      dataCy: 'manage-templates-section',
      acl: [
        {
          resource: CarmResources.DECLARATIONS,
          group: GroupTypes.Reader,
        },
      ]
    },
    {
      localizationKey: 'statements-of-adjustment',
      path: RoutesConst.Statements_Of_Adjustment_List,
      dataCy: 'statements-of-adjustment-section',
      acl: [
        {
          resource: CarmResources.DECLARATIONS,
          group: GroupTypes.Reader,
        },
      ]
    },
    {
      localizationKey: 'duty-drawbacks',
      path: RoutesConst.Dutydrawbacks_Main,
      dataCy: 'duty-drawbacks-section',
      acl: [
        {
          resource: CarmResources.DECLARATIONS_DDB_NONIMP,
          group: GroupTypes.Reader,
        }
      ]
    },
    {
      localizationKey: 'summary-drawback-activity',
      path: RoutesConst.Declarations_SDA_Main,
      dataCy: 'summary-drawback-activity-section',
      acl: [
        {
          resource: CarmResources.DECLARATIONS_SDA,
          group: GroupTypes.Reader,
        },
      ]
    },
    {
      localizationKey: 'requestDeclarationReport',
      path: RoutesConst.Declaration_Reports,
      dataCy: 'request-declaration-report-section',
      acl: [
        {
          resource: CarmResources.DECLARATIONS_REPORTING,
          group: GroupTypes.Editor,
        },
      ]
    },
    {
      localizationKey: 'listRequestedDeclarationReport',
      path: RoutesConst.Declaration_Reports_List,
      dataCy: 'requested-declaration-report-section',
      acl: [
        {
          resource: CarmResources.DECLARATIONS_REPORTING,
          group: GroupTypes.Reader,
        },
      ]
    },
  ],
});

applicationFeatures.set(ApplicationFeatureName.RULINGS, {
  path: RoutesConst.Rulings,
  localizationKey: 'application_features.rulings',
  dataCy: 'rulings-features',
  acl: [
    {
      resource: CarmResources.RULINGS,
      group: GroupTypes.Reader,
    },
    {
      resource: CarmResources.APPEALS,
      group: GroupTypes.Reader,
    },
    {
      resource: CarmResources.ENFORCEMENT_ACTIONS,
      group: GroupTypes.Reader,
    },
    {
      resource: CarmResources.COMPLIANCE,
      group: GroupTypes.Reader,
    },
  ],
  sections: [
    {
      localizationKey: 'rulings',
      path: RoutesConst.Rulings_RulingsRequests,
      dataCy: 'rulings-section',
      acl: [
        {
          resource: CarmResources.RULINGS,
          group: GroupTypes.Reader,
        },
      ],
    },
    {
      localizationKey: 'appeals',
      path: RoutesConst.Appeals_List,
      dataCy: 'appeals-section',
      acl: [
        {
          resource: CarmResources.APPEALS,
          group: GroupTypes.Reader,
        },
      ],
    },
    {
      localizationKey: 'enforcement-actions',
      path: RoutesConst.Enforcement_Actions,
      dataCy: 'enforcement-actions-section',
      acl: [
        {
          resource: CarmResources.ENFORCEMENT_ACTIONS,
          group: GroupTypes.Reader,
        },
      ],
    },
    {
      localizationKey: 'compliance-verification',
      path: RoutesConst.Compliance_Verification,
      dataCy: 'compliance-verification-section',
      acl: [
        {
          resource: CarmResources.COMPLIANCE,
          group: GroupTypes.Reader,
        },
      ],
    },
  ],
});

applicationFeatures.set(ApplicationFeatureName.UPLOADS, {
  path: RoutesConst.UploadDocuments_StepOne,
  localizationKey: 'application_features.uploads',
  dataCy: 'uploads-features',
  acl: [
    {
      resource: CarmResources.DOCUMENTS,
      group: GroupTypes.Editor,
    }
  ],
  sections: []
});

applicationFeatures.set(ApplicationFeatureName.HOMEPAGE, {
  path: RoutesConst.PublicHome,
  localizationKey: 'application_features.homepage',
  dataCy: 'Homepage',
  sections: [
    {
      localizationKey: 'login',
      path: RoutesConst.Login,
      dataCy: 'Homepage-Login',
      isPublic: true
    },
    {
      localizationKey: 'onboarding',
      path: RoutesConst.PublicOnboardingDocumentation,
      dataCy: 'onboarding',
      isPublic: true
    },
    {
      localizationKey: 'bulletins',
      path: RoutesConst.PublicBulletins,
      dataCy: 'bulletins',
      isPublic: true
    },
    {
      localizationKey: 'brokers',
      path: RoutesConst.PublicCustomBrokers,
      dataCy: 'brokers',
      isPublic: true
    },
    {
      localizationKey: 'API',
      path: RoutesConst.PublicCarmApi,
      dataCy: 'API',
      isPublic: true
    },
    {
      localizationKey: 'rulings',
      path: RoutesConst.PublicNationalRulings,
      dataCy: 'rulings',
      isPublic: true
    },
    {
      localizationKey: 'FAQ',
      path: RoutesConst.PublicFaq,
      dataCy: 'FAQ',
      isPublic: true
    }
  ],
});

export const applicationFeaturesArray = (): IApplicationFeature[] => {
  const ret: IApplicationFeature[] = [];
  applicationFeatures.forEach(
    (value: IApplicationFeature, key: ApplicationFeatureName) => {
      ret.push({ ...value });
    }
  );
  return ret;
};
